import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ReactNode} from 'react'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {StyledAddressCardSubtitle, StyledAddressCardTitle, StyledAddressCardWrapper} from './style'

interface AdddressCardProps {
    icon: ReactNode
    title?: string
    subtitle?: string
    kicker: string
    border?: 'left' | 'right'
    isLoading?: boolean
    isError?: boolean
}

export const AddressCard = ({icon, title, subtitle, kicker, border, isLoading, isError}: AdddressCardProps) => {
    return (
        <StyledAddressCardWrapper gap={1} fullWidth $border={border}>
            {isLoading ? (
                <>
                    <Skeleton width={20} height={20} />
                    <Flexbox direction="column" gap={0.5} fullWidth>
                        <Skeleton height={20} />
                        <Skeleton height={20} />
                    </Flexbox>
                </>
            ) : (
                <>
                    {icon}
                    <Flexbox direction="column" gap={1} fullWidth>
                        <p>{kicker}</p>
                        <Flexbox direction="column" gap={0.5} fullWidth>
                            <StyledAddressCardTitle $hasError={!!isError}>{title}</StyledAddressCardTitle>
                            {subtitle && <StyledAddressCardSubtitle>{subtitle}</StyledAddressCardSubtitle>}
                        </Flexbox>
                    </Flexbox>
                </>
            )}
        </StyledAddressCardWrapper>
    )
}
